import { Stack } from "@mui/material";
import { useSearchParams } from "react-router-dom";

import { HubBackButton, HubButton } from "../../components";

import { StyledTitledSubStack, StyledTitleStack } from "./styles";
import { MODE_DAILY, getDefaultRange } from "./dateHelper";

const ScheduleBar = ({ useExport, controls, children }) => {
  const [_, setSearchParams] = useSearchParams();

  const writeRange = (updates) => {
    setSearchParams((prev) => {
      const next = new URLSearchParams(prev);
      Object.entries(updates).forEach(([k, v]) => next.set(k, v));
      return next;
    });
  };

  const handleReset = () => writeRange(getDefaultRange(MODE_DAILY));

  return (
    <StyledTitleStack>
      <StyledTitledSubStack disableYPadding>
        <HubBackButton />
        {children}
      </StyledTitledSubStack>
      <StyledTitledSubStack>
        <Stack direction="row" gap="25px" alignItems="center">
          <Stack direction="row" gap="10px" alignItems="center">
            <HubButton
              variant="text"
              size="xsmall"
              icon="RefreshCw"
              onClick={handleReset}
              iconProps={{ size: "12px" }}
            />
            {controls}
          </Stack>
        </Stack>
        {useExport && (
          <HubButton
            variant="contained"
            color="neutral"
            size="xsmall"
            icon="Download"
            label="Download"
            onClick={() => window.print()}
            iconProps={{ size: "10px", sx: { marginRight: "5px" } }}
          />
        )}
      </StyledTitledSubStack>
    </StyledTitleStack>
  );
};

export default ScheduleBar;
